import { Component, OnInit } from '@angular/core';
import { AppImages } from 'src/resources/app_images';

@Component({
  templateUrl: './notfound.component.html',
  styleUrls: ['./notfound.component.scss']
})
export class NotfoundComponent implements OnInit {

  constructor() { }

  readonly appLogoPath = AppImages.focaliLogo192Path;

  ngOnInit(): void {
  }

}
